import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const ImagePreviewDialog = ({ open, onClose, src, alt = "activity attachment" }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          width: "100%",
          m: fullScreen ? 0 : 2,
        },
      }}
    >
      <DialogTitle>Image Preview</DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        {src && (
          <img
            src={src}
            alt={alt}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: fullScreen ? "calc(100vh - 120px)" : "80vh",
              objectFit: "contain",
              display: "block",
            }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImagePreviewDialog;